const __script_base__ = {
  name: 'WAbsolute',
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {}
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('uc-slot', {
    staticClass: "w-absolute",
    attrs: {
      "name": "default",
      "position": "absolute"
    }
  });
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/AbsoluteContainer/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);